import { Routes, Route, Navigate } from "react-router-dom";

import Layout from "./components/Layout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Contacts from "./pages/Contacts";
import Campaign from "./pages/Campaign";
import CampaignHistory from "./pages/CampaignHistory";
import Analytics from "./pages/Analytics";
import Admin from "./pages/Admin";
import Templates from "./pages/Templates";
import AdminUsers from "./pages/AdminUsers";
import BotSettings from "./pages/BotSettings";
import Inbox from "./pages/Inbox";
import FollowupSequences from "./pages/FollowupSequences";

import MetaInbox from "./pages/MetaInbox";
import AIAdsStudio from "./pages/AIAdsStudio";
import Products from "./pages/Products";
import Orders from "./pages/Orders";
import Profile from "./pages/Profile";
import PosterPlanner from "./pages/PosterPlanner";
import SubscriptionLocked from "./pages/SubscriptionLocked";

function PrivateRoutes() {
  const token = localStorage.getItem("token");

  if (!token) return <Navigate to="/login" replace />;

  return <Layout />;
}

function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />

      <Route path="/" element={<PrivateRoutes />}>
        <Route index element={<Dashboard />} />
        <Route path="contacts" element={<Contacts />} />
        <Route path="campaign" element={<Campaign />} />
        <Route path="history" element={<CampaignHistory />} />
        <Route path="analytics" element={<Analytics />} />
        <Route path="admin" element={<Admin />} />
        <Route path="templates" element={<Templates />} />
        <Route path="bot-settings" element={<BotSettings />} />
        <Route path="inbox" element={<Inbox />} />
        <Route path="meta-inbox" element={<MetaInbox />} />
        <Route path="ai-ads" element={<AIAdsStudio />} />
        <Route path="products" element={<Products />} />
        <Route path="orders" element={<Orders />} />
        <Route path="profile" element={<Profile />} />
        <Route path="poster-planner" element={<PosterPlanner />} />
        <Route path="subscription-locked" element={<SubscriptionLocked />} />
        <Route path="followup-sequences" element={<FollowupSequences />} />

         {/* Admin */}
        <Route path="admin/users" element={<AdminUsers />} />
        
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
      
    </Routes>
  );
}

export default App;